<header class="header">
    <div class="container-xxl gx-0">
        <div class="d-flex align-items-center">
            <div>
                <app-menu-mobile [menuItems]="menuItems" [isMainPage]="(isMainPage$ | async) || true" [compact]="(compact$ | async) || false"></app-menu-mobile>
                <app-menu-desktop [menuItems]="menuItems" [isMainPage]="(isMainPage$ | async) || false"></app-menu-desktop>
            </div>
            <div class="ms-auto d-none d-md-flex">
                <app-search></app-search>
            </div>
        </div>
        <div class="nav-i18n d-none d-md-flex">
            <app-menu-languages />
        </div>
    </div>
</header>
